import { render, staticRenderFns } from "./ApplicationReview.vue?vue&type=template&id=0844e403&scoped=true&"
import script from "./ApplicationReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationReview.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReview.vue?vue&type=style&index=0&id=0844e403&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844e403",
  null
  
)

export default component.exports